<template>
  <section id='ranking'>
    <div class="top">
      <img src="@/assets/images/miao/left_2.png" alt="" @click='closePage'>
      <div>
        <h1>助力主播分30万颗“糖果”</h1>
        <p>2月11日 21:09开奖</p>
      </div>
      <span></span>
    </div>
    <div class="user_img">
      <!-- 第二名 -->
      <dl>
        <dt>
          <img class='user_top_img' :src="listThree[1] ? listThree[1].headimage : like" alt="" v-if='listThree[1]'>
          <img class='decorate' src="@/assets/images/miao/num2.png" alt="" v-if='listThree[1]'>
          <img class='decorate' src="@/assets/images/miao/null_2.png" alt="" v-if='!listThree[1]'>
        </dt>
        <dd>
          <p class="name">{{listThree[1] ? listThree[1].nickname : '虚位以待'}}</p>
        </dd>
      </dl>
      <!-- 第一名 -->
      <dl>
        <dt>
          <img class='user_top_img' :src="listThree[0] ? listThree[0].headimage : like" alt="" v-if='listThree[0]'>
          <img class='decorate' src="@/assets/images/miao/num1.png" alt="" v-if='listThree[0]'>
          <img class='decorate' src="@/assets/images/miao/null_1.png" alt="" v-if='!listThree[0]'>
        </dt>
        <dd>
          <p class="name">{{listThree[0] ? listThree[0].nickname : '虚位以待'}}</p>
        </dd>
      </dl>
      <!-- 第三名 -->
      <dl>
        <dt>
          <img class='user_top_img' :src="listThree[2] ? listThree[2].headimage : like" alt="" v-if='listThree[2]'>
          <img class='decorate' src="@/assets/images/miao/num3.png" alt="" v-if='listThree[2]'>
          <img class='decorate' src="@/assets/images/miao/null_3.png" alt="" v-if='!listThree[2]'>
        </dt>
        <dd>
          <p class="name">{{listThree[2] ? listThree[2].nickname : '虚位以待'}}</p>
        </dd>
      </dl>
    </div>
    <div class="arena">
      <dl>
        <dt @click='openPage(1)'></dt>
        <dd>
          <p>将获得糖果x4万</p>
        </dd>
      </dl>
      <dl>
        <dt @click='openPage(0)'></dt>
        <dd>
          <p>将获得糖果x5万</p>
        </dd>
      </dl>
      <dl>
        <dt @click='openPage(2)'></dt>
        <dd>
          <p>将获得糖果x3万</p>
        </dd>
      </dl>
    </div>
    <div class="list">
      <ul>
        <li v-for='(item, index) in list' :key='index'>
          <div class="list_left">
            <div class="list_num">
              <img v-if='index == 0' src="@/assets/images/miao/num4_1.png" alt="">
              <img v-if='index == 1' src="@/assets/images/miao/num5_1.png" alt="">
              <img v-if='index == 2' src="@/assets/images/miao/num6_1.png" alt="">
              {{index > 2? index+4 : ''}}
            </div>
            <div class="list_user">
              <div class="list_user_img">
                <!-- 456名头像图片有个框 -->
                <img v-if='item.level' :src="item.headimage" alt="">
                <img v-if='!item.level' src="@/assets/images/miao/null.png" alt="">
                <img v-if='index == 0' src="@/assets/images/miao/num4.png" alt="">
                <img v-if='index == 1' src="@/assets/images/miao/num5.png" alt="">
                <img v-if='index == 2' src="@/assets/images/miao/num6.png" alt="">
              </div>
              <div class="list_user_name">
                <p class="name">
                  {{item.nickname}}
                  <img :src="require(`@/assets/images/live/${item.level}.png`)" alt="" v-if='item.level'>
                </p>
                <p v-show='item.rid'>房间号：{{item.rid}}</p>
                <p v-show='!item.level'>虚位以待</p>
              </div>
            </div>
          </div>
          <div class='list_right'>
            <p>将获得</p>
            <p>糖果{{jiudian[index]}}</p>
          </div>
        </li>
        <!-- <li>
          <div class="list_left">
            <div class="list_num">
              7
            </div>
            <div class="list_user">
              <div class="list_user_img">
                <img src="@/assets/images/miao/like.png" alt="">
                <img src="@/assets/images/miao/num4.png" alt="">
              </div>
              <div class="list_user_name">
                <p class="name">
                  刘宝宝前来报道
                </p>
                <p>房间号：57721328</p>
              </div>
            </div>
          </div>
          <div class='list_right'>
            <p>100万糖果</p>
            <p>将获得</p>
          </div>
        </li> -->
      </ul>
      <div class="low_ranking">
        <section>
          <div>11~100名</div>
          <p>将瓜分5万糖果</p>
        </section>
        <section>
          <div>101~500名</div>
          <p>将瓜分4万糖果</p>
        </section>
        <section>
          <div>501~1000名</div>
          <p>将瓜分2万糖果</p>
        </section>
        <section>
          <div>1001~名</div>
          <p>将瓜分1.1万糖果</p>
        </section>
      </div>
    </div>
    <div class="anchor_bottom" v-if='is_anchor == 1'>
      <p class="my" v-if='unlock_rank == 1'>我的“招财榜”：第{{rank}}名</p>
      <p class="not_unlock" v-if='unlock_rank == 0'>解锁“招财猫”后，可进入排行榜分30万颗“糖果”礼物</p>
    </div>
  </section>
</template>

<script>
import { get } from '@/http'
import api from '@/http/api'
export default {
  name : "ranking",
  data() {
    return {
      listThree: [{}, {}, {}], // 前三名数据
      list: [{}, {}, {},{}, {}, {},{}],
      like: require('@/assets/images/miao/like.png'),
      is_anchor: 2, // 判断是否为主播
      unlock_rank: '',
      rank: '',
      jiudian: ['x2万', 'x1.5万', 'x1万', 'x7000', 'x4000', 'x2000', 'x1000']
    }
  },
  mounted() {
    document.title = '喵喵雨'
    setTimeout(() => {
      console.log(window.winOcx)
      let that = this
      if (window.winOcx.getUserData) {
        window.winOcx.getUserData(function(data){
          sessionStorage.setItem('initData', JSON.stringify(data))
          // 榜单信息
          that.getAnchorRankListHttp()
          // 判断是否是主播
          that.checkAnchorIdentityHttp()
        })
        window.winOcx.resetBackground()
      } else {
        console.log('没有拿到getUserData方法')
      }
    }, 1000);
  },
  methods: {
    // 获取榜单信息,有空值状态
    getAnchorRankListHttp () {
      get(api.getAnchorRankList).then(res => {
        if (res.code == 200) {
          let rankList = res.data.list
          this.listThree = rankList
          let list = rankList.splice(3, 7)
          if (list.length < 7) {
            let len = 7-list.length
            for (let i=0; i<len; i++) {
              list.push({})
            }
          }
          this.list = list
           let { unlock_rank, rank } = res.data.anchor_info
          // 是否解锁参数
          this.unlock_rank = unlock_rank
          this.rank = rank
        }
      })
    },
    // 判断是否是主播
    checkAnchorIdentityHttp () {
      get(api.checkAnchorIdentity).then(res => {
        if (res.code == 200) {
          let { is_anchor } = res.data
          if (is_anchor == 1) {
            this.is_anchor = 1
          }
        }
      })
    },
    // 打开直播间
    openPage (num) {
      let { listThree } = this
      let rid = listThree[num] ? listThree[num].rid : ''
      if (rid) {
        let initData = JSON.parse(sessionStorage.getItem('initData'))
        if (initData.os == 2) {
          window.winOcx.closeMyCatView()
        }
        window.winOcx.closePage()
        window.winOcx.openPage('room',{
          'rid' :rid,
          'status' :1
        });
      }
    },
    closePage () {
      window.winOcx.closePage()
    }
  }
}
</script>
<style lang="scss" scoped>
  @mixin font($size, $color){
      color: $color;
      font-size: $size
  }

  #ranking{
    height: 1110px;
    overflow-y: scroll;
    background: #FFD6A7;
    border-radius: 16px 16px 0px 0px;
    .top{
      display: flex;
      justify-content: space-between;
      margin-top: 36px;
      padding: 0 32px;
      img{
        width: 32px;
        height: 32px;
      }
      span{
        width: 32px;
        height: 32px;
      }
      div{
        width: 480px;
        height: 100px;
        background-image: url('../../assets/images/miao/bg_3.png');
        background-size: 100% 100%;
        text-align: center;
        h1{
          @include font(32px, #FFEFDB);
          line-height: 44px;
          margin-top: 14px;
        }
        p{
          @include font(20px, #FFEFDA);
          line-height: 28px;
        }
      }
    }
    .user_img{
      display: flex;
      justify-content: space-between;
      margin: 16px 32px 0 32px;
      dl{
        width: 228px;
      }
      dt{
        width: 146px;
        height: 178px;
        position: relative;
        text-align: center;
        margin: 0 auto;
        .user_top_img{
          width: 128px;
          height: 128px;
          margin: 32px 0 0 8px;
          border-radius: 50%;
        }
        .decorate{
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
        }
      }
      dd{
        p{
          @include font(22px, #994A0B);
          text-align: center;
          font-weight: 600;
          margin-top: 2px;
          line-height: 32px;
        }
      }
      dl:nth-child(1) {
        dt{
          margin-top: 88px;
        }
      }
      dl:nth-child(2) {
        dt{
          width: 166px;
          height: 200px;
          .user_top_img{
            width: 148px;
            height: 148px;
            margin: 32px 0 0 8px;
          }
        }
        dd{
          p{
            margin-top: 14px;
          }
        }
      }
      dl:nth-child(3) {
        dt{
          margin-top: 88px;
        }
      }
    }
    .arena{
      width: 678px;
      height: 226px;
      margin-left: 36px;
      background-image: url('../../assets/images/miao/arena.png');
      background-size: 100% 100%;
      margin-top: -50px;
      display: flex;
      justify-content: space-between;
      padding: 0 40px;
      box-sizing: border-box;
      dl{
        &:nth-child(1) {
          margin-top: 106px;
        }
        &:nth-child(2) {
          margin-top: 68px;
        }
        &:nth-child(3) {
          margin-top: 106px;
        }
        dt{
          width: 116px;
          height: 58px;
          background-image: url('../../assets/images/miao/look.png');
          background-size: 100% 100%;
          margin: 0 auto;
        }
        dd{
          margin-top: -7px;
          p{
            @include font(20px, #C45700);
            transform: scale(1);
          }
        }
      }
    }
    .list{
      margin: -18px 24px 24px 24px;
      background: url('../../assets/images/miao/bg_4.png');
      background-size: 100% 100%;
      padding-bottom: 36px;
      li{
        display: flex;
        justify-content: space-between;
        padding-top: 52px;
        .list_left{
          flex: 1;
          display: flex;
          .list_user{
            display: flex;
          }
        }
        .list_user_name{
          margin-left: 16px;
          p:nth-child(1) {
            @include font(28px, #994A0B);
            line-height: 40px;
            font-weight: 400;
            img{
              width: 70px;
              height: 30px;
              margin-left: 12px;
              position: relative;
              top: 4px;
            }
          }
          p:nth-child(2) {
            @include font(22px, #C45700);
            line-height: 32px;
            margin-top: 8px;
          }
          p:nth-child(3) {
            @include font(28px, #994A0B);
            line-height: 80px;
          }
        }
        .list_num{
          width: 42px;
          height: 44px;
          margin-top: 18px;
          margin-left: 24px;
          text-align: center;
          @include font(32px, #FF7100);
          img{
            width: 42px;
            height: 34px;
            margin-top: 6px;
          }
        }
        .list_user_img{
          width: 80px;
          height: 80px;
          position: relative;
          margin-left: 20px;
          img:nth-child(1) {
            width: 100%;
            height: 100%;
            border-radius: 50%;
          }
          img:nth-child(2) {
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
          }
        }
        .list_right{
          padding-right: 28px;
          p:nth-child(2){
            @include font(22px, #994A0B);
            font-weight: 600;
            line-height: 32px;
            text-align: right;
          }
          p:nth-child(1) {
            @include font(20px, #994A0B);
            line-height: 40px;
            margin-top: 10px;
            text-align: right;
          }
        }
      }
    }
    .low_ranking{
      margin: 0 32px;
      section{
        display: flex;
        justify-content: space-between;
        margin-top: 52px;
        div{
          width: 152px;
          height: 38px;
          background: #FFD6A7;
          border: 1px solid #FDBF7A;
          text-align: center;
          line-height: 38px;
          border-radius: 4px;
          font-size: 24px;
          color: #994A0B;
        }
        p{
          @include font(22px, #994A0B);
          font-weight: 400;
          line-height: 38px;
        }
      }
    }
    .anchor_bottom{
      margin: 24px 24px 32px 24px;
      height: 112px;
      background-image: url('../../assets/images/miao/bg_bottom.png');
      background-size: 100% 100%;
      text-align: center;
      line-height: 112px;
      .not_unlock{
        @include font(28px, #994A0B);
      }
      .my{
        @include font(34px, #994A0B);
      }
    }
  }
</style>
